export const searchFilterTextOptions = [
  { value: 1, label: 'Contains' },
  { value: 2, label: 'Is exactly' },
  { value: 3, label: 'Starts with' },
  { value: 4, label: 'Ends with' },
];

export const searchFilterDateOptions = [
  { value: 1, label: 'Exactly' },
  { value: 2, label: 'Before' },
  { value: 3, label: 'After' },
  { value: 4, label: 'Between' },
];

export const defaultPerPageOptions = [10, 25, 50, 100];
